
import { Icon } from '../../ui/icon';
import { ReactComponent as EmpowerGPTLogo } from 'src/assets/tailwind/empowergpt-logo.svg';

export const Logo = () => (
  <Icon icon={EmpowerGPTLogo} width={140} height={40} />
);
